import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgRunStudy = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill="none" fillRule="evenodd">
      <path
        d="M12 1c1.299 0 2.54.083 3.679.242l.56.086C19.643 1.896 22 3.18 22 5v5.755a7.994 7.994 0 0 0-1.999-1.173V7.527c-.98.51-2.27.896-3.761 1.145l-.561.086A26.78 26.78 0 0 1 12 9a26.78 26.78 0 0 1-3.679-.242l-.56-.086C6.27 8.423 4.98 8.037 4 7.528L4 12c0 .227.277.483.773.734l.266.125.3.123.164.061.35.119.38.115c.265.075.548.146.849.213l.464.097.488.09.511.08c.26.037.53.071.806.101l.278.027a7.944 7.944 0 0 0-.547 1.967l.104.012c-2.1-.213-3.908-.667-5.186-1.331V19c0 .227.277.483.773.734l.266.125.3.123.164.061.35.119.38.115c.265.075.548.146.849.213l.464.097.488.09.511.08c.26.037.53.071.806.101l.56.054.114.009a8.035 8.035 0 0 0 1.682 2.078L12 23c-.543 0-1.076-.014-1.596-.042l-.616-.04-.602-.054c-4.064-.411-7.041-1.73-7.18-3.717L2 19V5l.006-.16C2.14 3.107 4.458 1.88 7.76 1.329l.561-.086A26.78 26.78 0 0 1 12 1zm0 2-.307.002c-.51.006-1.006.028-1.487.063l-.568.049-.551.06c-.452.054-.883.12-1.29.195l-.477.093-.451.1-.425.108C4.937 4.073 4 4.587 4 5c0 .413.937.927 2.444 1.33l.425.107.451.101.477.093c.407.075.838.14 1.29.195l.55.06.569.049a24.638 24.638 0 0 0 3.588 0l.568-.049.551-.06c.452-.054.883-.12 1.29-.195l.477-.093.451-.1.425-.108C19.063 5.927 20 5.413 20 5c0-.413-.937-.927-2.444-1.33l-.425-.107-.451-.101-.477-.093c-.407-.075-.838-.14-1.29-.195l-.55-.06-.569-.049A24.638 24.638 0 0 0 12 3z"
        fill="navy"
        fillRule="nonzero"
      />
      <g transform="translate(10.88 11)">
        <circle fill="navy" cx={6} cy={6} r={6} />
        <path stroke="#FFF" fill="#FFF" strokeLinecap="round" strokeLinejoin="round" d="m8.22 6-4.2 2.8V3.2z" />
      </g>
    </g>
  </svg>
);
export default SvgRunStudy;
